import * as React from 'react'
import {mutate as globalMutate} from 'swr'
import {firstResponseApiError} from '@frontrow/console/src/entities/models/api-error'

import SpinnerWrapper from '@frontrow/console/src/components/common/spinner-wrapper'
import CreateItem from '@frontrow/console/src/components/pages/piggy-store-page/create-item/create-item'

import {postItem, type ItemParamsT} from '@frontrow/console/src/helpers/api-items'

import {usePiggyStore, PIGGY_STORE_SWR_KEY} from '@frontrow/console/src/hooks/api'

export function CreateItemContainer(): React.ReactElement {
  const {data, isLoading, error, mutate} = usePiggyStore()

  const createItem = React.useCallback(
    async (postParams: ItemParamsT): Promise<number | undefined | null> => {
      try {
        const newItem = await postItem(postParams)

        // Optimistically update the cache with the new item
        if (data) {
          const updatedData = {
            ...data,
            itemsData: [...data.itemsData, newItem]
          }
          mutate(updatedData, {revalidate: false})
        }

        // Revalidate to ensure data consistency
        await globalMutate(PIGGY_STORE_SWR_KEY)

        return newItem.id
      } catch (err) {
        const apiError = firstResponseApiError(err)
        throw new Error(apiError.message)
      }
    },
    [data, mutate]
  )

  const storeCategoryVariations = data?.storeCategoryVariations || []
  const errorMessage = error?.message || error

  const createItemError =
    storeCategoryVariations.length === 0 && !isLoading
      ? 'Store category variations not loaded'
      : errorMessage

  return (
    <SpinnerWrapper isLoading={isLoading}>
      <CreateItem
        error={createItemError}
        createItem={createItem}
        storeCategoryVariations={storeCategoryVariations}
      />
    </SpinnerWrapper>
  )
}
